import axios from "axios";
import FilterOrder from "components/Filter/FilterOrder";
import UpdateStatus from "components/Modal/UpdateStatus";
import SearchBar from "components/SearchBar/SearchBar";
import SearchBarOrder from "components/SearchBar/SearchBarOrder";
import SummaryUser from "components/Summary/SummaryUser";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";

import Swal from "sweetalert2";

// components

export default function CardOrderTable() {
  const [datas, setDatas] = useState("");
  const [datasSearch, setDatasSearch] = useState("");
  const [pending, setPending] = useState(true);
  const [result, setResult] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [ordersCode, setOrdersCode] = useState("");
  const { user } = useSelector(state => state.user)
  const [products, setProducts] = useState("");
  const [perPage, setPerPage] = useState(10)
  const [totalRows, setTotalRows] = useState(200)
  const [currentRow, setCurrentRow] = useState(null);
  const [buttonEdit, setButtonEdit] = useState(false);

  datas && datas.sort((a, b) => (a.ordersCode > b.ordersCode ? -1 : 1))

  const fetchOrders = async pageNum => {
    setPending(true);

    axios.post(`http://${process.env.REACT_APP_API_URL}/orders/search-all`, { page: pageNum, pageSize: perPage }, {
      headers: {
        bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setDatas(response.data);
        setResult(response.data);
        setPending(false);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error.response.data.message);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/orders/count`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setTotalRows(response.data.totals);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // window.location.reload();
      // console.log(error.response.data.message);
    });
  };

  const handlePageChange = page => {
    fetchOrders(page);
  };

  const handlePerRowsChange = async (newPerPage, pageNum) => {
    setPending(true);
    // console.log(newPerPage,pageNum);
    axios.post(`http://${process.env.REACT_APP_API_URL}/orders/search-all`, { page: pageNum, pageSize: newPerPage }, {
      headers: {
        bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setDatas(response.data);
        setResult(response.data);
        setPerPage(newPerPage);
        setPending(false);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error.response.data.message);
    });
  };

  useEffect(() => {
    fetchOrders(1); // fetch page 1 of users

  }, []);

  // useEffect(() => {


  //   axios.get(`http://${process.env.REACT_APP_API_URL}/products/search-All`, {
  //     headers: {
  //       Bearer: localStorage.getItem('token')
  //     }
  //   }).then((response) => {
  //     // console.log(response);
  //     if (response.status === 200) {
  //       setProducts(response.data);
  //     }
  //   }

  //   ).catch((error) => {
  //     console.log(error);
  //     if (error.response.data.status === 401) {
  //       window.location.href = "/auth/login";
  //     }
  //   });
  // }, [])

  const checkStatus = (status) => {
    switch (status) {
      case "Waiting Shipping":
        return false;
        
      case "Waiting Payment":
        return user.role !== 2 ? true : false;
        
      case "Shipping":
        return user.role !== 2 ? true : false;
        
      case "Completed":
        return user.role !== 2 ? true : false;
        
      case "Cancelled":
        return user.role !== 2 ? true : false;
        
      case "Return":
        return user.role !== 2 ? true : false;
        
      case "Lost":
        return user.role !== 2 ? true : false;
        
      case "Claim":
       return user.role !== 2 ? true : false;
        
      default:
        return true;
    }
  }
  const columns = [
    {
      name: 'อัพเดทสถานะ',
      button: "true",
      cell: (row) => user.role != 2 && <button onClick={() => (setShowModal(true), setOrdersCode(row.ordersCode))}><i className="mr-2 text-sm fas fa-truck" /></button>,

    },
    {
      name: 'วันที่เบิก',
      selector: row => row.orderDate,
      center: "true",
      sortable: true,
    },
    {
      name: 'ราคาสุทธิ',
      selector: row => row.net,
      center: "true",
      sortable: true,
    },
    {
      name: 'สถานะ',
      selector: row => row.status,
      center: "true",
      sortable: true,
    },
    {
      name: 'วิธีการชำระเงิน',
      selector: row => row.paymentMethod,
      cell: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.paymentMethod}</div>,
      center: "true",
      sortable: true,
    },
    {
      name: 'หมายเลข Order',
      selector: row => row.ordersCode,
      cell: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.ordersCode}</div>,
      center: "true",
      sortable: true,
    },
    {
      name: 'หมายเลขติดตาม',
      selector: row => row.trackingNumber,
      cell: row => <div style={{ overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses' }}>{row.trackingNumber}</div>,
      center: "true",
      sortable: true,
    },
    {
      name: 'Sales',
      selector: row => row.sales,
      center: "true",
      sortable: true,
    },

    {
      name: 'ชื่อลูกค้า',
      selector: row => row.customer,
      center: "true",
      sortable: true,
    },
    {
      name: 'เบอร์โทรศัพท์',
      selector: row => row.tel,
      center: "true",
      sortable: true,
    },


    {
      name: 'Edit',
      button: "true",
      cell: (row) => checkStatus(row.status) && <button onClick={() => window.location.href = "/order/update/" + row.ordersCode}><i className="mr-2 text-sm fas fa-pen" /></button>,
    },
    // {
    //   name: 'Delete',
    //   button: "true",
    //   cell: (row) => user.role != 2 && <button onClick={() => handleDelete(row)}><i className="mr-2 text-sm fas fa-trash" /></button>,
    // },
  ];
  const columns2 = [
    {
      name: '#',
      selector: row => row.no,
      width: "50px",

    },
    {
      name: 'ชื่อสินค้า',
      selector: row => row.productName,
      center: true
    },
    {
      name: 'จำนวน',
      selector: row => row.qty,
      center: true
    },
    {
      name: 'ราคาต่อหน่วย',
      selector: row => row.pricePerUnit,
      center: true
    },
    {
      name: 'ราคาลดต่อหน่วย',
      selector: row => row.discountPerUnit,
      center: true
    },
    {
      name: 'ยอดรวม',
      selector: row => row.net,
      center: true
    },
  ];
  const columnsHistory = [
    {
      name: '#',
      selector: row => row.index,
      width: "50px",

    },
    {
      name: 'วันที่',
      selector: row => new Date(row.updateDate).toLocaleDateString("en"),
      center: true
    },
    {
      name: 'สถานะ',
      selector: row => row.status,
      center: true
    },
    {
      name: 'ผู้ดำเนินการ',
      selector: row => row.updateBy,
      center: true
    },
    {
      name: 'vat',
      selector: row => row.vat,
      center: true
    },
    {
      name: 'ยอดสุทธิ',
      selector: row => row.net,
      center: true
    },
  ];

  const handleDelete = (row) => {
    const ordersCode = { isDelete: 1, ordersCode: row.ordersCode }
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: "true",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`http://${process.env.REACT_APP_API_URL}/orders/save-delete`, ordersCode, {
          headers: {
            Bearer: localStorage.getItem('token')
          }
        }).then((response) => {
          // console.log(response);
          if (response.status === 200) {
            Swal.fire({
              title: "Deleted!",
              text: "Your file has been deleted.",
              icon: "success"
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
            //  window.location.href = "/product";
          }
        }
        ).catch((error) => {
          if (error.response.data.status === 401) {
            window.location.href = "/auth/login";
          }
          //  console.log(error);
          console.log(error.response.data.message);
        });
      }
    });
  }

  const customStyles = {
    table: {
      style: {
        borderRadius: "20px",
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        // override the row height
        '&:hover': {
          // cursor: 'pointer',
          backgroundColor: "#B4BDFF",

        },
        overflow: 'hidden', whiteSpace: 'wrap', textOverflow: 'ellipses'

      },
    },
    expanderCell: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",

      },
    },
    expanderRow: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        // backgroundColor: "#a3a4fb",
        backgroundColor: "gray",

      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",
        textAlign: "right"
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',

      },

    },

  };


  const ExpandedComponent = ({ data }) => {
    console.log(data);
    return (
      <>
        <div className="grid p-5 bg-gray">
          <div>
            <div className="block w-full mb-1 overflow-x-auto rounded-lg ">
              {/* Projects table */}

              <DataTable
                data={data && data?.items}
                columns={columns2}
                customStyles={customStyles}
              >
              </DataTable>
            </div>
          </div>
          <div className="flex justify-center" >
            <div className="grid p-5 " style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}>
              <p>รหัสใบเบิกสินค้า : {data.ordersCode}
                <br />
                ชื่อลูกค้า : {data.customer}
                <br />
                ที่อยู่ : {data.address}
                <br />
                เบอร์โทรศัพท์ : {data.tel}
                <br />
                วิธีการชำระเงิน : {data.paymentMethod}
                <br />
                มูลค่ารวมสุทธิ : {data.net}
                <br />
                โซเชียล : {data.social}
              </p>
              <br />
              <p>{data.ordersCode}
                <br />
                {data.customer}
                <br />
                {data.address}
                <br />
                {data.tel}
                <br />
                {data.paymentMethod}
                <br />
                {data.net}
                <br />
                {data.social}
              </p>
            </div>

            <div className="grid p-5 " style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }} >

              <p>สถานะ : {data.status}</p>
              <br />
              <p>ช่องทางการจัดส่ง : {data.deliveryChannel}</p>
              <p>หมายเลขติดตาม : {data.trackingNumber}</p>
              <p>จำนวนสินค้าทั้งหมด : {data.productQty}</p>
              <p>มูลค่าก่อนรวมภาษี : {data.exVat}</p>
              <p>ค่าขนส่ง : {data.shippingCost}</p>
              <p>ภาษีมูลค่าเพิ่ม % : {data.vat}</p>
              <p>หมายเหตุ : {data.note}</p>


            </div>
            <div className="grid p-5" style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}>
              <p>ตัวแทนขาย : {data.sales}</p>
              <br />
              <p>วันที่เบิก : {new Date(data.orderDate).toLocaleDateString("th")}</p>
              <p>วันที่ได้รับ : {new Date(data.receivedDate).toLocaleDateString("th")}</p>
              <p>คนสร้าง : {data.createBy}</p>
            </div>
            {data.paymentSlip && <div className="grid p-5" style={{ backgroundColor: "#83A2FF", borderRadius: "20px", margin: "15px" }}>
              <img src={`data:image/jpeg;base64,${data.paymentSlip}`} alt={data.productName} width="400" height="400" />
            </div>}
          </div>



          <div>
            <div className="block w-full mb-1 overflow-x-auto rounded-lg ">
              {/* Projects table */}
              <label className="mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase " >History</label>
              <DataTable
                data={data && data?.history}
                columns={columnsHistory}
                customStyles={customStyles}

              >
              </DataTable>
            </div>
          </div>
        </div>
      </>
    );
  };

  // console.log(datasSearch);
  return (
    <>
      <UpdateStatus showModal={showModal} setShowModal={setShowModal} ordersCode={ordersCode} data={result} datasSearch={datasSearch} />
      <div className="flex justify-between p-5 orderbar" >
        <SearchBarOrder data={datas} setResult={setResult} setPending={setPending} setTotalRows={setTotalRows} setPerPage={setPerPage} setDatasSearch={setDatasSearch} />
        {/* <FilterOrder data={datas} setResult={setResult} /> */}
        <SummaryUser />
      </div>
      <div className="block w-full mb-1 overflow-x-auto rounded-lg ">
        {/* Projects table */}
        {!datasSearch ? <DataTable
          data={result}
          columns={columns}
          pagination
          customStyles={customStyles}
          progressPending={pending}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          paginationServer
          paginationTotalRows={totalRows}
          paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          onRowExpandToggled={(bool, row) => setCurrentRow(row)}
          expandableRowExpanded={(row) => (row === currentRow)}
          expandOnRowClicked
          onRowClicked={(row) => setCurrentRow(row)}
        >
        </DataTable>
          :
          <DataTable
            data={user.role == 2 ? datasSearch && datasSearch?.filter(x => x.createBy == user.username || x.sales == user.username) : datasSearch}
            columns={columns}
            pagination
            customStyles={customStyles}
            progressPending={pending}
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
            onRowExpandToggled={(bool, row) => setCurrentRow(row)}
            expandableRowExpanded={(row) => (row === currentRow)}
            expandOnRowClicked
            onRowClicked={(row) => setCurrentRow(row)}
          >
          </DataTable>}
      </div>
    </>
  );
}
